<template>
	<div class="businesses-management-container">
		<AppCard :title="getString('copy_menu')" class="card-management">
			<template v-slot:body>
				<div class="copy-row">
					<div class="from-row">
						<AppSelect :label="getString('from_business')" :values="selectBusinesses" @selected="i => selectChange(true, i)" />
						<AppSelect :label="getString('from_menu')" class="mt-12" :selected-index="menuSelectedIndex" :class="{disabled: selectMenus.length === 0}" :values="selectMenus"  @selected="selectMenuChange" />
					</div>
					<div class="to-row">
						<AppSelect :label="getString('to_business')" :values="selectBusinesses" @selected="i => selectChange(false, i)" />
						<AppButton :loading="loadingCopy" :text="getString('copy')" class="mt-12" :disabled="!fromBusiness || !toBusiness || menuSelectedIndex === null" @click="copyMenu" />
					</div>
				</div>
			</template>
		</AppCard>
		<AppNotification :title="getString('success')" :body-text="getString('menu_copied_successfully')" :type="1" ref="success-copy" />
		<AppNotification :title="getString('error')" :body-text="getString('failed_to_copy')" :type="-2" ref="fail-copy" />
	</div>
</template>

<script>
import AppCard from "@/shared/components/AppCard.vue";
import MapCluster from "@/user/components/overview-businesses/MapCluster.vue";
import AppSelect from "@/shared/components/AppSelect.vue";
import AppButton from "@/shared/components/AppButton.vue";
import {useLanguageStore} from "@/shared/stores";
import {useSuperStore} from "@/user/stores";
import {useAnalyticsStore} from "@/console-new/stores";
import {formatDateTime} from "@/shared/helpers/dates";
import API from "@/shared/helpers/API";
import AppNotification from "@/shared/components/AppNotification.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const superStore = useSuperStore();
		const analyticsStore = useAnalyticsStore();
		return {formatDateTime, getString: languageStore.getString, superStore, analyticsStore}
	},
	name: "BusinessesManagementContainer",
	components: {AppNotification, AppButton, AppSelect, MapCluster, AppCard},
	data() {
		return {
			fromBusiness: null,
			toBusiness: null,
			menus: [],
			menuSelectedIndex: null,
			loadingCopy: false,
		}
	},
	computed: {
		selectBusinesses() {
			return this.superStore.businesses ? this.superStore.businesses.map(b => {
				return b.name ? b.name : "";
			}) : [];
		},
		selectMenus() {
			return this.menus ? this.menus.map(m => {
				return m.name ? m.name : "";
			}) : [];
		}
	},
	methods: {
		selectChange(from, i) {
			if(from) {
				this.fromBusiness = this.superStore.businesses[i];
			} else {
				this.toBusiness = this.superStore.businesses[i];
			}
		},
		selectMenuChange(i) {
			this.menuSelectedIndex = i;
		},
		refreshMenus(businessId) {
			API.init().getMenus(businessId, (response) => {
				if (response && response.result === "OK" && response.menus) {
					this.menus = response.menus;
					if(this.menus.length > 0) {
						this.menuSelectedIndex = 0;
					}
				}
			});
		},
		copyMenu() {
			if(this.fromBusiness && this.toBusiness && this.menuSelectedIndex !== null) {
				this.loadingCopy = true;
				const fromMenu = this.menus[this.menuSelectedIndex];
				API.init().copyMenu(this.fromBusiness.business_id, this.toBusiness.business_id, fromMenu.menu_id, (response) => {
					this.loadingCopy = false;
					if (response && response.result === "OK") {
						this.$refs["success-copy"].openNotification();
						this.menuSelectedIndex = null;
						if(this.fromBusiness.business_id === this.toBusiness.business_id) {
							this.refreshMenus(this.fromBusiness.business_id);
						}
					} else {
						this.$refs["fail-copy"].openNotification();
					}
				});
			}
		}
	},
	mounted() {
		if (this.superStore.businesses === null) {
			this.superStore.fetchBusinesses();

		}
	},
	watch: {
		fromBusiness(newVal, oldVal) {
			if(newVal && (!oldVal || newVal.business_id !== oldVal.business_id)) {
				this.menus = [];
				this.menuSelectedIndex = null;
				this.refreshMenus(newVal.business_id);
			}
		}
	}
}
</script>

<style scoped lang="scss">
.businesses-management-container {
	max-width: 1400px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	padding: var(--main-padding);

	.card-management {
		width: 50%;

		@media (max-width: 768px) {
			width: 100%;
		}
	}

	.copy-row {
		display: flex;
		justify-content: space-between;
		align-items: stretch;

		.from-row {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			width: 50%;

			.select-wrapper {
				width: 48%;
			}
		}

		.to-row {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			width: 50%;

			.select-wrapper {
				width: 48%;
			}
		}

		@media (max-width: 380px) {
			flex-direction: column;

			.from-row, .to-row {
				width: 100%;
				.select-wrapper {
					width: 100%;
				}
			}

			.to-row {
				margin-top: 12px;
			}
		}
	}
}

</style>